// extracted by mini-css-extract-plugin
module.exports = {"SignInUpForm":"SignInUpForm_SignInUpForm__3-ol2","Input":"SignInUpForm_Input__3xaLZ","Heading":"SignInUpForm_Heading__1Ba_q","FormText":"SignInUpForm_FormText__27r3P"};